//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/utils/common.js";
export default {
  name: "AddInsure",

  data() {
    const validateCompanyName = (rule, value, callback) => {
      if (this.form.companyId == "") {
        this.form.companyName = "";
        callback(new Error("请选择保险机构"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      rules: {
        companyName: [
          {
            required: true,
            message: "请选择保险机构",
            trigger: "blur",
            validator: validateCompanyName,
          },
        ],
        businessAddress: [
          {
            required: true,
            message: "请填写保险机构业务网点名称",
            trigger: "blur",
          },
        ],
        divideLevel: [
          { required: true, message: "请选择划分级别", trigger: "blur" },
        ],
        provinceId: [
          { required: true, message: "请选择管辖地区", trigger: "change" },
        ],
        cityId: [
          { required: true, message: "请选择管辖地区", trigger: "change" },
        ],
        areaId: [
          { required: true, message: "请选择管辖地区", trigger: "change" },
        ],
        loginName: [
          { required: true, message: "请填写登录账号", trigger: "blur" },
          { min: 6, max: 20, message: "长度在6到20位", trigger: "blur" },
          { trigger: "blur", validator: common.checkIdAccount },
        ],
        password: [
          { required: true, message: "请填写12-20位账号密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "请输入12-20位账号密码",
            trigger: "blur",
          },
          { trigger: "blur", validator: common.checkIdPassword },
        ],

        contactName: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { validator: common.checkMobile, required: true, trigger: "blur" },
        ],
        subDomain: [
          { required: true, message: "请填写登录地址", trigger: "blur" },
          { trigger: "blur", validator: common.checkSubDomain },
          { min: 2, max: 20, message: "长度在4到20位", trigger: "blur" },
        ],
        businessZoneId: [
          { required: true, message: "请选择业务区域", trigger: "change" },
        ],
        businessPersonId: [
          { required: true, message: "请选择业务员", trigger: "change" },
        ],
      },
      form: {
        provinceId: "", //住址省id
        provinceName: "", //住址省name
        cityId: "", //住址市id
        cityName: "", //住址市name
        areaId: "", //所在地区县id
        areaName: "", //所在地区县name
        loginName: "", // 登陆
        mobile: "", // 手机
        contactName: "", // 人
        subDomain: "", // 网址
        businessPersonId: "", // 业务员
        businessZoneId: "", // 业务区域
        password: "", // 密码
        divideLevel: 1, // 划分级别
        companyId: "", // 银行名称
        companyName: "",
        businessAddress: "", //业务网点名称
      },
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], // 业务员列表
      showPassword: false, // 是否展示密码
      levels: [
        { label: "全国级", id: 1 },
        { label: "省级", id: 2 },
        { label: "市级", id: 3 },
        { label: "县级", id: 4 },
      ], // 划分级别列表
      provinceList: [], // 省列表
      cityList: [], // 市列表
      areaList: [], // 区县列表
      loading: false,
    };
  },
  components: {},
  filters: {},
  watch: {
    checkedZone(newVal) {
      this.form.businessPersonId = "";
      this.dutyPersonList = [];
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      this.$refs.ruleForm.validateField(["businessZoneId"]);
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  computed: {
    address() {
      let str;
      switch (this.form.divideLevel) {
        case 2:
          str = "provinceId";
          break;
        case 3:
          str = "cityId";
          break;
        case 4:
          str = "areaId";
          break;
      }
      return str;
    },
  },
  created() {
    this.getSelectedCityOptions(1, "provinceList");
    this.getBusinessZoneData();
  },
  mounted() {},
  methods: {
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type, name, id, loading) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
        name && this.initCityName(id, name, data, loading);
      } catch (error) {}
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChangeAddress(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.form.cityId = "";
          this.form.areaId = "";
          this.cityList = [];
          this.areaList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.form.areaId = "";
          this.areaList = [];
          list = "cityList";
          break;
        case "":
          list = "areaList";
          break;
        default:
          break;
      }
      city = this[list].find((item) => {
        return item.i == pid;
      });
      this.form[name] = city.n;
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @Description: change级别
     */
    handleLevel(val) {
      if (val == 1) {
        let _form = this.form;
        _form.provinceId = "";
        _form.cityId = "";
        _form.areaId = "";
      }
    },
    /**
     * @Description: 显示/隐藏 密码
     */
    handleChangePassword(type) {
      this[type] = !this[type];
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    /**
     * @Description: 保存县账号
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.addCtCountyAccount();
        } else {
        }
      });
    },
    /**
     * @Description: 添加县账号
     */
    async addCtCountyAccount() {
      try {
        let { status } = await this.$http.insure.addInsurAccount(this.form);
        if (status == 1) {
          this.fullscreenLoading = false;
          this.$message.success("添加保险机构账号成功");
          this.$router.push({
            path: "/insure/manage/list",
          });
        }
      } catch (error) {
        this.fullscreenLoading = false;
        console.log(error);
      }
    },
    // 保险机构
    insureAssociate(key, cb) {
      if (key !== "") {
        this.loading = true;
        this.$http.insure
          .queryInsurOreByKey({ key })
          .then(({ data }) => {
            this.loading = false;
            // let arr = data.map( (item,index) => ({name:item,value:index}));
            cb(data); // 渲染回调
          })
          .catch((res) => {
            this.loading = false;
          });
      }
    },
    /**
     * @description: 选择保险机构
     * @Author: juanjuanhui
     * @Date: 2023-10-26 10:38:21
     * @param {*} item
     */
    handleSelectInsureAssociate(item) {
      this.form.companyId = item.id;
      this.$refs.ruleForm.clearValidate("companyName");
    },
    /**
     * @description: 输入保险机构时
     * @Author: juanjuanhui
     * @Date: 2023-10-26 11:22:54
     * @param {*} item
     */
    handleInputInsureAssociate(item) {
      this.form.companyId = "";
    },
  },
};
